module.exports = "<p>toast works!</p>\n"